import React, { useState, useEffect } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  CircularProgress,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const PowerBiDashboardPage = () => {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const url = process.env.REACT_APP_IMPACT_NETWORK; 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        bgcolor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Top App Bar */}
      <AppBar
        position="static"
        sx={{
          background: theme.palette.primary.main,
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate(-1)}
            sx={{ mr: 1 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 600 }}
          >
            Network Dashboard
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Dashboard Content */}
      <Box
        sx={{
          flex: 1,
          position: "relative",
          bgcolor: "#f5f6fa",
        }}
      >
        {!isIframeLoaded && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <CircularProgress size={60} color="primary" />
          </Box>
        )}

        <Box
          component="iframe"
          src={url}
          title="Network Dashboard"
          allowFullScreen
          onLoad={() => setIsIframeLoaded(true)}
          sx={{
            display: isIframeLoaded ? "block" : "none",
            border: "none",
            width: "100%",
            height: "calc(100vh - 64px)", // Full screen minus AppBar height
          }}
        />
      </Box>
    </Box>
  );
};

export default PowerBiDashboardPage;
